import React, { FC } from 'react'
import { IAutocompleteOption } from 'transfix-ui/components/Autocomplete'
import { IShipmentIssueFollowerTypes } from 'types/graphqlTypes'
import { IShipmentIssueDetailsFragment } from '../../../ShipmentIssues/graphql/ShipmentIssueDetailsFragment'
import TagSubscribers from '../TagSubscribers'
import { TOnSubmitField } from './types'

interface ISelectSubscribersProps {
  subscribers?: IShipmentIssueDetailsFragment['subscribers'] | null
  onChange: TOnSubmitField
  readOnly?: boolean
}

export const SelectSubscribers: FC<ISelectSubscribersProps> = ({
  onChange,
  readOnly = false,
  subscribers: subscribersProp,
}) => {
  const onUpdateSubscribers = (subscribers: Partial<IAutocompleteOption>[]) => {
    const formattedSubscribers = subscribers.map(subscriber => ({
      followerId: subscriber.id || '',
      followerType: (subscriber.groupName || 'User') as IShipmentIssueFollowerTypes,
    }))

    onChange({ subscribers: formattedSubscribers })
  }

  const subscribers =
    subscribersProp?.map(subscriber => ({
      id: subscriber.followerId,
      text: `${subscriber.firstName} ${subscriber.lastName}`,
      groupName: subscriber.followerType,
      groupIndex: 1,
    })) || []

  return (
    <TagSubscribers
      readOnly={readOnly}
      value={subscribers}
      onUpdateSubscribers={onUpdateSubscribers}
    />
  )
}

export default SelectSubscribers
